module.exports = __webpack_public_path__ + "img/empty-event.d3035651.svg";